<div class="FlightStatusAlert-containerAlert fw-medium-x lh-30px">
  <img alt="" class="FlightStatusAlert-iconAlert" src="../../../../../assets/images/Alert-icon.svg" />
  <div *ngIf="typeAlert == typeIrops.CANCELED && typeAlertOn == ''"> <!-- srIropsCtrl.cancelado -->
    {{ "srIrops.cancelledFlight" | translate }}
  </div>
  <div *ngIf="typeAlert == typeIrops.DELAYED && typeAlertOn == ''"> <!-- !srIropsCtrl.cancelado -->
    {{ "srIrops.changeFlight" | translate }}
  </div>
  <div *ngIf="typeAlert == typeIrops.USPERSONINFO && typeAlertOn == ''"> <!-- !srIropsCtrl.informacion importante -->
    {{ "usPerson.alert" | translate }}
  </div>
  <div *ngIf="typeAlert == 'closed' &&typeAlertOn == ''"> <!-- !srIropsCtrl.informacion importante -->
    {{ "CLOSED" | translate }}
  </div>
  <div *ngIf="typeAlert == typeIrops.STBFULLIST && typeAlertOn == ''"> <!-- !srIropsCtrl.informacion importante -->
    {{ "noticeStb.fullist" | translate }}
  </div>
  <div *ngIf="typeAlertOn == 'Onboarding' "> <!-- !srIropsCtrl.informacion importante -->
    {{ "noticeOnBoarding.boarding" | translate }}
  </div>
</div>
